module.exports = "/build/web/svg/sponsor/hegeman.07b7ca3a59d785feb0cd7e913b67e688.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/hegeman.svg
// module id = 211
// module chunks = 24